import { render, staticRenderFns } from "./TakeOutEleDetail.vue?vue&type=template&id=29af07bd"
import script from "./TakeOutEleDetail.vue?vue&type=script&lang=js"
export * from "./TakeOutEleDetail.vue?vue&type=script&lang=js"
import style0 from "./TakeOutEleDetail.vue?vue&type=style&index=0&id=29af07bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports